import React from "react";
import { useState, useEffect } from 'react';

//React Router
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";

//MUI Components
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../config/api-config.js';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

function Login() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    let { destination } = useParams();
    if (destination === "home") { destination = "" }

    const [identifiant, setIdentifiant] = useState();
    const [password, setPassword] = useState();
    const [errorCode, setErrorCode] = useState(0);

    function handleFormSubmit() {
        console.log(destination);
        console.log(identifiant);
        console.log(password);

        setErrorCode(0);

        if (identifiant === undefined || identifiant.length < 2 || password === undefined || password.length < 2) {
            setErrorCode(1);
        }
        else {
            ///verifier le login
            axios.post(`${baseURL}/user/login`, {
                email: identifiant,
                password: password
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        console.log(response.data.token);
                        window.localStorage.setItem("token-nestor-manager", response.data.token)
                        window.localStorage.setItem("token-nestor-manager-user", identifiant)

                        navigate("/manager/" + destination);

                    }
                    else { //insertion problème
                        setErrorCode(2)
                        return response.status
                    }
                })
                .catch(error => {
                    setErrorCode(2)
                    return error
                })

        }

    }

    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <HeaderStep step={""} title={"Login Manager"} custom={""} />

            <div className="login-form">
                <TextField
                    //fullWidth
                    className="login-form-input"
                    required
                    label="Identifiant"
                    variant="outlined"
                    name="identifiant"
                    value={identifiant}
                    onChange={e => setIdentifiant(e.target.value)}
                />
                <TextField
                    //fullWidth
                    className="login-form-input"
                    required
                    label="password"
                    variant="outlined"
                    name="password"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                {errorCode === 1 ?
                    <Alert
                        className="login-form-alert"
                        severity="error">Veillez à bien remplir correctement tous les champs.
                </Alert>
                    : null}
                {errorCode === 2 ?
                    <Alert
                        className="login-form-alert"
                        severity="error">La combinaison identifiant / mot de passe est incorrecte
                </Alert>
                    : null}


                <Button

                    className="login-form-bouton"
                    variant="contained"
                    onClick={_ => handleFormSubmit()}>
                    Se connecter
                </Button>

            </div>


        </main>
    )
}




export default Login

